/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'connected-react-router';
import { connect } from 'react-redux';
import { OneFaceProvider } from 'onefaceui-react-components';

import LicenseStatusModal from 'react/containers/layout/LicenseStatusModal';
import LogoffAlertModal from 'react/containers/modals/LogoffAlertModal';
import Header from 'react/containers/layout/Header';
import Content from 'react/containers/layout/Content';

import { getOneFaceProviderResources } from 'react/utils/onefaceLibraryUtils';
import { mapDispatchToProps } from 'react/api/actions/tabs';
import { actionCreators as authActions } from 'react/api/actions/auth';

import LoadingPageSkeleton from './LoadingPageSkeleton/LoadingPageSkeleton';

function Base({ configuration, router, openPanelAtLogin, routeDivisionModal }) {
  const validateUserAndUrlAccess = () => {
    const { loggedUser: user } = configuration;
    const {
      location: { pathname }
    } = router;

    if (pathname !== '/login' && user && !user.id) {
      window.globalStore.dispatch(authActions.request());
    } else if (user && !user.id) {
      window.globalStore.dispatch(replace('/login'));
    } else if (pathname === '/help_releasenotes' || pathname === '/welcome') {
      window.globalStore.dispatch(replace('/RouteMonitor'));
    }
  };

  const onClick = () => {
    window.removeMenu();
  };

  const hideMenusBasedOnFeatures = () => {
    const { featureStates, menus } = configuration;

    if (featureStates) {
      featureStates.forEach((feature) => {
        const { enabled, menusNames } = feature;

        if (!enabled && menusNames) {
          menusNames.forEach((name) => {
            menus.forEach((m, i) => {
              if (m.name === name) {
                menus.splice(i, 1);
              }
              m.submenus.forEach((sub, j) => {
                if (sub.name === name) {
                  m.submenus.splice(j, 1);
                }
              });
            });
          });
        }
      });
    }
  };

  useEffect(() => {
    validateUserAndUrlAccess();
  }, [router?.location?.pathname, configuration.loggedUser?.id]);

  useEffect(() => {
    hideMenusBasedOnFeatures();
  }, [configuration.featureStates, configuration.menus]);
  
  return Monet?.Session?.User ? (
    <OneFaceProvider resources={getOneFaceProviderResources()}>
      <div>
        <div id="templates_container" />
        <div id="page_container" onClick={onClick}>
          <LicenseStatusModal />
          <LogoffAlertModal />
          <Header />
          <Content
            menus={configuration.menus}
            panels={configuration.panels}
            openPanelAtLogin={openPanelAtLogin}
            featureStates={configuration.featureStates}
            routeDivisionModal={routeDivisionModal}
          />
        </div>
      </div>
    </OneFaceProvider>
  ) : (
    <LoadingPageSkeleton />
  );
}

Base.propTypes = {
  configuration: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  openPanelAtLogin: PropTypes.func.isRequired,
  routeDivisionModal: PropTypes.object.isRequired
};

export default connect(
  ({ configuration, router, routeDivisionModal }) => ({
    configuration,
    router,
    routeDivisionModal
  }),
  mapDispatchToProps
)(Base);
